import React, { createContext, useContext, useRef } from 'react';

interface CropperRefsContextType {
  cropperRefs: React.MutableRefObject<any[]>;
}

const CropperRefsContext = createContext<CropperRefsContextType | undefined>(undefined);

export const CropperRefsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const cropperRefs = useRef<any[]>([]);
  return (
    <CropperRefsContext.Provider value={{ cropperRefs }}>
      {children}
    </CropperRefsContext.Provider>
  );
};

export const useCropperRefs = (): CropperRefsContextType => {
  const context = useContext(CropperRefsContext);
  if (!context) {
    throw new Error('useCropperRefs must be used within a CropperRefsProvider');
  }
  return context;
};